module.exports = __webpack_public_path__ + "static/media/cat.d62490e7.png";